import React from 'react'
import Input from '../../../../../utils/components/Input/Input'
import style from './ProducDevolve.module.css'


const ProducDevolve = ({ checked,reason,setReason,setQuantity, quantity, expeditionDate, expirationDate, stock, name, id,reasonsfordeletion }) => {
  return (
    <div className={`${style.card_container}`}>
      <div className={`${style.card}${checked ? " " + style.card_active : ""}`}>
        <div>Lote {name}</div>
        <div>Fecha expedición {new Date(expeditionDate).toLocaleDateString()}</div>
        <div>Fecha expiración {new Date(expirationDate).toLocaleDateString()}</div>
        <div>Stock {stock}</div>
        <Input classNameInput={checked ? style.input_active:""} placeholder='Cantidad a devolver' type='number' max={stock} value={quantity} onChange={setQuantity}  />
        <select className={`input-select-style${checked ? " " + style.input_active:""}`} value={reason} onChange={setReason} >
          <option value="">Seleccione</option>
       {
         reasonsfordeletion.map(reazon=>(
          <option key={reazon._id} value={reazon._id}>{reazon.name}</option>
         ))
       }
        </select>
      </div>

    </div>
  )
}

export default ProducDevolve